export const _config = {
  // key是buttonKey，value是对应的文本
  content_text: {
    depart: '发车成功！发车通知短信发送失败！',
    arrival: '到达成功！到达通知短信发送失败！',
    sign_complete: '签收成功！签收通知短信发送失败！',
  },
};
